export default class {
    constructor(params) {
        this.settings = Object.assign({}, this.defaults(), params)
        $(this.settings.targetSelector).each((idx, element) => {
            this.addTargetObj(element)
            if (this.settings.fileNameKey && $(element).find(`input[name="${this.settings.fileNameKey}"]`).val()) {
                $(element).find('.del').show();
            }
        })
    }
    defaults() {
        return {
            fileNameKey: null,
            targetSelector: '.item.image',
            uploadPath: '/api/file/upload',
            uploadKeyName: 'file',
            deleteType: 'api', // api or dom
            deletePath: '/api/file/del',
            deleteSelector: '.del',
            deleteConfirm: true,
            deleteConfirmMessage: 'このデータを削除します。\nこの操作は元に戻せません。よろしいですか？',
            typeFilter: [],
            fileSizeLimit: null,
            token: null,
            uploadDir: '/',
            addParams: null,
        }
    }

    addTargetObj(element) {
        let fileObj = $(element).find('input[type="file"]')
        fileObj.on('change.fileUpload', event => {
            this.loadLocalImage(element, event)
        })
        $(element).find(this.settings.deleteSelector).on('click', event => {
            if(this.settings.deleteConfirm && !window.confirm(this.settings.deleteConfirmMessage)) return false;
            let path = $(element).find('input[type="hidden"]').val()
            this.delete(path)
                .then(resp => {
                    $(element).find('input[type="hidden"]').val('')
                    $(event.currentTarget).hide()
                    this.deletedFile(element, resp)
                })
        })
    }

    loadLocalImage(element, event) {
        const targetObj = event.currentTarget;
        // ファイル情報を取得
        const fileData = event.target.files[0];

        // フィルター処理
        let chk = this.settings.typeFilter.filter(val => {
            return fileData.type.match(val)
        });
        if (!chk.length) {
            alert('指定されたファイルタイプは選択できません')
            return;
        }

        // ファイルサイズ制限
        if (fileData.size > this.settings.fileSizeLimit * 1048576) { // 1024 * 1024
            alert(`${this.settings.fileSizeLimit}MB以内のファイルを選択してください。`)
            return;
        }

        // FileReaderオブジェクトを使ってファイル読み込み
        const reader = new FileReader();

        // ファイル読み込みに成功したときの処理
        reader.onload = () => {
            this.loadedFile(element, reader, fileData)
            this.upload(targetObj)
                .then(resp => {
                    this.uploadedFile(element, resp, fileData)
                })
                .catch(error => {
                    this.error(element)
                })
        }
        // ファイル読み込みを実行
        reader.readAsDataURL(fileData);
    }

    upload(obj) {
        const fd = new FormData();
        fd.append(this.settings.uploadKeyName, $(obj).prop("files")[0])
        fd.append('token', this.settings.token)
        fd.append('uploadDir', this.settings.uploadDir)
        if(this.settings.addParams){
            Object.keys(this.settings.addParams).forEach(_key => {
                fd.append(_key, this.settings.addParams[_key])
            })
        }
        return new Promise((resolve, reject) => {
            $.ajax({
                url: this.settings.uploadPath,
                type: 'post',
                dataType: 'json',
                data: fd,
                processData: false,
                contentType: false
            })
                .done(res => {
                    resolve(res)
                })
                .fail((jqXHR, statusText, errorThrown) => {
                    reject(errorThrown)
                });
        })
    }

    delete(path) {
        return new Promise((resolve, reject) => {
            switch(this.settings.deleteType){
                case "api":
                    $.ajax({
                        url: this.settings.deletePath,
                        type: 'post',
                        dataType: 'json',
                        data: {
                            path,
                            token: this.settings.token
                        }
                    })
                    .done(function (res) {
                        resolve(res)
                    })
                    .fail(function (jqXHR, statusText, errorThrown) {
                        reject(errorThrown)
                    });
                    break;
                case "dom":
                    resolve()
                    break;
            }
        })
    }

    loadedFile(element, reader) {
        $(element).find('figure').remove()
        let imgObj = $('<img />').attr('src', reader.result)
        imgObj = $('<figure />').addClass('photo uploading').append(imgObj)
        $(element).append(imgObj);
        $(element).find('.del').show()
    }
    uploadedFile(element, resp) {
        $(element).find('figure').removeClass('uploading')
        $(element).find('input[type="hidden"]').val(resp.imgPath)
    }
    deletedFile(element, resp) {
        console.log(element,resp)
        return null
    }
    error(element){
        alert('アップロードエラー')
    }
}